import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { createElement } from "react";
import { publicLoader } from "./loader";
import { apiRunner } from "./api-runner-browser";
import { grabMatchParams } from "./find-path";

// Renders page
let PageRenderer = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(PageRenderer, _React$Component);
  function PageRenderer() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = PageRenderer.prototype;
  _proto.render = function render() {
    const props = _objectSpread(_objectSpread({}, this.props), {}, {
      params: _objectSpread(_objectSpread({}, grabMatchParams(this.props.location.pathname)), this.props.pageResources.json.pageContext.__params),
      pathContext: this.props.pageContext
    });
    const [replacementElement] = apiRunner("replaceComponentRenderer", {
      props: this.props,
      loader: publicLoader
    });
    const pageElement = replacementElement || /*#__PURE__*/createElement(this.props.pageResources.component, _objectSpread(_objectSpread({}, props), {}, {
      key: this.props.path || this.props.pageResources.page.path
    }));
    const wrappedPage = apiRunner("wrapPageElement", {
      element: pageElement,
      props
    }, pageElement, _ref => {
      let {
        result
      } = _ref;
      return {
        element: result,
        props
      };
    }).pop();
    return wrappedPage;
  };
  return PageRenderer;
}(React.Component);
export default PageRenderer;